import { graphql } from 'react-apollo'
import { DUPLICATE_FILES } from '../../graphql/mutations'

export default graphql(DUPLICATE_FILES, { name: 'duplicateFiles' })
